/**
 * What the comments API supports, read from the data itself. Every optional
 * piece of a thread (the marker, replies, Mark done, the M7 change, Show on the
 * page) renders only when these say so, so nothing is ever faked while
 * backend #128 (anchors, replies, resolve, edit, delete, mentions) and #125
 * (M7 changes) are open. One place, so turning a piece on is one change.
 */
type ThreadShape = {
  anchor?: unknown;
  replies?: readonly unknown[];
  resolvedAt?: string | null;
  m7Change?: unknown;
  comment: { sendState?: "sending" | "failed" };
};

/** The thread is pinned to a part of the page: marker, "· the hook", Show on the page. */
export const hasAnchors = (thread: ThreadShape): boolean => !!thread.anchor;

/** The API sends replies for this thread (even none): Reply and the reply field. */
export const supportsReplies = (thread: ThreadShape): boolean => Array.isArray(thread.replies);

/** The API knows whether the thread is done: the Mark done box and "Done · n". */
export const supportsResolve = (thread: ThreadShape): boolean => thread.resolvedAt !== undefined;

export const isDone = (thread: ThreadShape): boolean => supportsResolve(thread) && !!thread.resolvedAt;

/** M7 drafted or suggested a change from this comment. */
export const hasM7Change = (thread: ThreadShape): boolean => !!thread.m7Change;

/** A post that is still going out or failed has no done box. */
export const canMarkDone = (thread: ThreadShape): boolean =>
  supportsResolve(thread) && !thread.comment.sendState;
